import React, {useState, useContext} from "react";
import { useHistory } from "react-router-dom";
import axios from 'axios';
import { Prevbutton } from "../../../assets/images";
import { ForgotPasswordValidator } from './forgotPasswordValidator'
import { useFormik } from "formik";
import { Input, Button, PageHeader } from "../../../components/";
import { EndPoints } from '../../../api'
import { AlertContext } from "../../../context/context";
import {
  check,
  forgotForm,
  loginSupportWrapper,
  loginSupportText,
  loginSupportLink,
  forgotPrevbuttonWrapper,
  forgotButtonWrapper,
  forgotBtn
} from "./forgotPassword.module.css";

const ForgotPassword = () => {
  const [loading, setLoading] = useState(false)
  const {setAlertState } = useContext(AlertContext)

  const handleOnSubmit = () => {
    setLoading(true)
    axios.post(EndPoints.forgotPassword, values).then((res) => {
      if(res.data?.success) {
        setLoading(false)
        setAlertState(
          {
            show: true,
            status: "Success",
            labelText: res.data?.message,
            type: "Password Success",
            failure: false,
        })
        setTimeout(() => {
          history.push('/')
        }, 3000)
      }
    }).catch((err) => {
      setLoading(false)
      setAlertState({ 
            show: true,
            status: "Failure",
            labelText: err?.response?.data?.message,
            type: "Password failed",
            failure: true
      })
    })
  }

  const { values, errors, handleChange, handleSubmit, touched } = useFormik({
    initialValues : {
      email: ""
    }, 
    validationSchema : ForgotPasswordValidator,
    onSubmit: handleOnSubmit
  })

  
  const history = useHistory();
  return (
    <div style={{width: "100%"}}>
    <form className={forgotForm} onSubmit={handleSubmit}>
      <div className={forgotPrevbuttonWrapper}>
        <img src={Prevbutton} onClick={()=>history.push('/')} alt="Previous Iocn" />
      </div>
      <PageHeader
        head="Forgot Password"
        text="Reset password to gain access to your profile"
      />
      <div className={check}>
        <Input
          type="text"
          name="email"
          placeholder="Enter email address"
          label="Email address"
          value={values.email}
          onChange={handleChange}
          errorText={touched.email? errors.email : ""}
        />
      </div>

      <div className={forgotButtonWrapper}>
        <Button
          buttonName={loading? "Loading..." : "Send reset Instructions" }
          main="fill"
          type="submit"
          className={forgotBtn}
        />
        <div className={loginSupportWrapper}>
          <p className={loginSupportText}>Experiencing Issues?</p>
          <span
            className={loginSupportLink}
            onClick={() => history.push("/contact")}
          >
            Contact support
          </span>
        </div>
      </div>
    </form>
  </div>
  );
};
export { ForgotPassword };
